import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nodata',
  templateUrl: './nodata.component.html',
  styleUrls: ['./nodata.component.css']
})
export class NodataComponent implements OnInit {

  title : String = "";
  details : String = "";

  constructor() { }

  ngOnInit(): void {
  }

  setDetails(title, details){
    this.title = title;
    this.details = details;
  }
  

}
